const urls = {
    onLine: 'https://backend.p2ipo.com/index.php', // 线上接口地址
    testLine: '', // 测试版接口地址
};
const baseUrl: String = urls.onLine;
export default baseUrl;